<template>
  <div class="container" :style="{'min-height': docHt + 'px'}">
    <div class="msg">支付成功</div>
    <div class="confirm-btn" @click="toJump">确认</div>
  </div>
</template>


<script>
export default {
  name: 'pay-success',
  data () {
    return {
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
    }
  },
  created() {
   
  },
  methods: {
    toJump() {
      // wx.miniProgram.switchTab({
      //   url: '/pages/index/index'
      // })
      wx.miniProgram.navigateTo({
        url: '/pagesCategory/accommodation/order-result'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  .msg{
    padding: 5rem 0 2rem;
    font-size: .8rem;
    color: #222;
    text-align: center;
  }
  .confirm-btn{
    width: 6rem;
    height: 2rem;
    line-height: 1.9rem;
    background: #47B6C7;
    font-size: .8rem;
    color: #fff;
    text-align: center;
    border-radius: .5rem;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/distribution/pay-success.vue